import { render, staticRenderFns } from "./PassAddEdit.vue?vue&type=template&id=fa2166f4&scoped=true"
import script from "./PassAddEdit.vue?vue&type=script&lang=js"
export * from "./PassAddEdit.vue?vue&type=script&lang=js"
import style0 from "./PassAddEdit.vue?vue&type=style&index=0&id=fa2166f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2166f4",
  null
  
)

export default component.exports